// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.currencyContainer_H_2jy {
  color: #264f88;
  font-weight: bold;
  border-bottom: 2px solid #264f88;
  gap: 5px;
  display: flex;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
  width: fit-content;
  div {
    gap: 5px;
  }
  span {
    color: #264f88;
  }
}

.currencyDropdownButton_DeB1o {
  display: flex;
  gap: 5px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
}
.chevronIcon_zABVg {
  margin-top: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/CurrencyDropdownBtn/CurrencyDropdownBtn.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,iBAAiB;EACjB,gCAAgC;EAChC,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB;IACE,QAAQ;EACV;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB","sourcesContent":[".currencyContainer {\n  color: #264f88;\n  font-weight: bold;\n  border-bottom: 2px solid #264f88;\n  gap: 5px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n  width: fit-content;\n  div {\n    gap: 5px;\n  }\n  span {\n    color: #264f88;\n  }\n}\n\n.currencyDropdownButton {\n  display: flex;\n  gap: 5px;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n}\n.chevronIcon {\n  margin-top: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"currencyContainer": `currencyContainer_H_2jy`,
	"currencyDropdownButton": `currencyDropdownButton_DeB1o`,
	"chevronIcon": `chevronIcon_zABVg`
};
export default ___CSS_LOADER_EXPORT___;
